import type { ReactNode } from 'react';

export function Facts({ items, cols, inline }: { items: [ReactNode, ReactNode][]; cols?: number; inline?: boolean }) {
  return (
    <dl className={inline ? 'facts facts-inline' : 'facts'} style={cols ? { gridTemplateColumns: `repeat(${cols}, minmax(0, 1fr))` } : undefined}>
      {items.map(([k, v], i) => (
        <div key={i}>
          <dt>{k}</dt>
          <dd>{v}</dd>
        </div>
      ))}
    </dl>
  );
}
